<template>
  <generic-view
    :title="$t('stages')"
    icon="walking"
    v-bind:show_plus="true"
    v-on:add="add"
  >
    <div class="ui error fluid message" v-if="stage_weighting_summation > 100">
      <div class="header">
        {{ $t("limit overflow") }}
      </div>
      <p>
        {{ $t("weighting summation is above limit, check stages weighting") }}
      </p>
    </div>
    <div class="ui info fluid message" v-if="stage_weighting_summation < 100">
      <div class="header">
        {{ $t("weighting incomplete") }}
      </div>
      <p>
        {{ $t("weighting summation is incomplete, check stages weighting") }}
      </p>
    </div>
    <div class="ui two column grid">
      <stage
        v-for="(stage, index) in stages"
        :key="index"
        :stage="stage"
        v-on:remove_stage="remove_stage"
      />
      <!-- <div class="column" v-for="(stage, stindex) in stages" :key="stindex">
        <div class="ui top attached menu">
          <div class="ui dropdown icon item" ref="module_dropdown">
            <i class="shoe prints icon"></i>
            <div class="menu">
              <div class="ui dropdown icon item">
                <i class="sliders horizontal icon"></i>
                {{ $t("configure") }}
              </div>
            </div>
          </div>
          <div class="ui dropdown icon item">
            {{ stage.name }} - {{ stage.weighting_percent }}%
          </div>
          <div class="right menu">
            <div
              class="ui dropdown icon item"
              style="padding: 0px 11px;"
              @click="remove_stage(stindex)"
            >
              <div class="button" :data-tooltip="$t('remove')">
                <i class="red trash icon" style="margin: 0"></i>
              </div>
            </div>
            <div class="ui dropdown icon item" @click="add_task(stindex)">
              <i class="green plus icon" style="margin: 0"></i>
            </div>
          </div>
        </div>
        <div class="ui bottom attached segment" ref="main_segment">
          <div class="ui form">
            <div class="fields">
              <div class="ten wide field">
                <label for="">{{ $t("name") }}</label>
                <input type="text" name="" v-model="stage.name" />
              </div>
              <div class="six wide field">
                <label for="">{{ $t("weighting") }} (%)</label>
                <input type="text" name="" v-model="stage.weighting_percent" />
              </div>
            </div>
          </div>
          <h4 class="ui dividing header">{{ $t("tasks") }}</h4>
          <div
            class="ui error message"
            style="display: inline-block"
            v-if="task_weighting_summation(stindex) > 100"
          >
            <div class="header">
              {{ $t("limit overflow") }}
            </div>
            <p>
              {{
                $t("weighting summation is above limit, check tasks weighting")
              }}
            </p>
          </div>
          <div class="ui form">
            <div class="fields" v-for="(task, idx) in stage.tasks" :key="idx">
              <div class="ten wide field">
                <label for="" v-if="idx == 0">{{ $t("name") }}</label>
                <input type="text" name="" v-model="stage.tasks[idx].name" />
              </div>
              <div class="four wide field">
                <label for="" v-if="idx == 0">{{ $t("weighting") }} (%)</label>
                <input
                  type="text"
                  name=""
                  v-model="stage.tasks[idx].weighting_percent"
                />
              </div>
              <div class="two wide field">
                <label for="" v-if="idx == 0">{{ $t("options") }}</label>
                <div
                  class="ui basic icon button"
                  @click="remove_task(stindex, idx)"
                >
                  <i class="red trash icon"></i>
                </div>
              </div>
            </div>
          </div>
          <div
            class="ui info message"
            style="display: inline-block"
            v-if="task_weighting_summation(stindex) < 100"
          >
            <div class="header">
              {{ $t("weighting incomplete") }}
            </div>
            <p>
              {{
                $t("weighting summation is incomplete, check tasks weighting")
              }}
            </p>
          </div>
        </div>
      </div> -->
    </div>
  </generic-view>
</template>

<script>
import GenericView from "@/components/GenericContainer";
import Stage from "@/modules/course_scoring/edit/Stage.vue";
import { v4 } from "uuid";
// import { cloneDeep } from "lodash";

export default {
  name: "CourseModalWeighting",
  components: {
    "generic-view": GenericView,
    Stage,
  },
  data() {
    return {
      stages: [],
    };
  },
  computed: {
    stage_weighting_summation() {
      return this.stages.reduce((prev, curr) => {
        if (curr.extra == true) return prev;
        else return prev + Number(curr.weighting_percent);
      }, 0);
    },
  },
  methods: {
    task_weighting_summation(index) {
      return this.stages[index].tasks.reduce((prev, curr) => {
        return prev + Number(curr.weighting_percent);
      }, 0);
    },
    add() {
      let vm = this;
      vm.stages.push({
        uuid: v4(),
        name: vm.$t("stage") + vm.stages.length,
        tasks: [],
        weighting_percent: 0,
        extra: false,
      });
    },
    getList() {
      return this.stages;
    },
    setList(stages) {
      this.stages = stages;
    },
    remove_stage(stage) {
      console.log("remove stage", stage);
      let trgtIndex = this.stages.findIndex((s) => {
        console.log(s);
        return s.name == stage.name;
      });
      if (trgtIndex >= 0) this.stages.splice(trgtIndex, 1);
    },
    add_task(index) {
      let vm = this;
      vm.stages[index].tasks.push({
        name: vm.$t("task") + vm.stages[index].tasks.length,
        weighting_percent: 0,
      });
    },
    remove_task(stageIndex, taskIndex) {
      let vm = this;
      vm.$alertify.confirm(vm.$t("are you sure to remove task?"), function() {
        vm.stages[stageIndex].tasks.splice(taskIndex, 1);
      });
    },
  },
  mounted() {},
  watch: {
    // stages() {
    //   let vm = this;
    //   setTimeout(() => {
    //     window.jQuery(".ui.slider").slider({
    //       min: 0,
    //       max: 100,
    //       start: 0,
    //       step: 5,
    //       onMove: function(value) {
    //         let stageIndex = window.jQuery(this).data("si");
    //         if (stageIndex >= 0)
    //           vm.stages[stageIndex].weighting_percent = value;
    //       },
    //     });
    //   }, 200);
    // },
  },
};
</script>
